import { Type } from 'class-transformer';
import { IsArray, IsEmail, IsMobilePhone, Length, Matches, ValidateNested } from 'class-validator';

import { AgreementUserModel } from '@onArte/shared/models/website/agreements';
import { passwordRegexp, phoneRegexp } from '@onArte/shared/regexp';

export class UserRegistrationModel {
  @Length(2, 64)
  public firstName: string;

  @Length(2, 64)
  public lastName: string;

  @Length(2, 64)
  @IsEmail()
  public email: string;

  @Length(9, 12)
  @Matches(phoneRegexp)
  @IsMobilePhone()
  public phone: string;

  @Length(8, 64)
  @Matches(passwordRegexp)
  public password: string;

  @IsArray()
  @ValidateNested()
  @Type(() => AgreementUserModel)
  public agreements: AgreementUserModel[];

  constructor(
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    password: string,
    agreements: AgreementUserModel[],
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.phone = phone;
    this.password = password;
    this.agreements = agreements;
  }
}
